import { useCallback, useMemo } from 'react';
import { useVersionedCache } from './useVersionedCache';
import { cmsApi, NganhHang } from '../services/cmsApi';

interface UseNganhHangReturn {
  mall: NganhHang[];
  regular: NganhHang[];
  loading: boolean;
  error: boolean;
  refresh: () => void;
}

/** Ngành hàng (hoa hồng) — cache version-gate + 24h. */
export function useNganhHang(): UseNganhHangReturn {
  const fetcher = useCallback(async (): Promise<{ mall: NganhHang[]; regular: NganhHang[] }> => {
    const [mall, regular] = await Promise.all([
      cmsApi.getNganhHang('mall'),
      cmsApi.getNganhHang('regular'),
    ]);
    return { mall, regular };
  }, []);

  const { data, loading, error, refresh } = useVersionedCache('tuki_nganhhang_cache', fetcher);

  const mall = useMemo(() => data?.mall ?? [], [data]);
  const regular = useMemo(() => data?.regular ?? [], [data]);

  return { mall, regular, loading, error, refresh };
}
